// extracted by mini-css-extract-plugin
module.exports = {"bxTextTruncateEnd":"Link-module--bx--text-truncate--end--20EKA","bxTextTruncateFront":"Link-module--bx--text-truncate--front--17m6C","link":"Link-module--link--PAAZ2"};